export const LOAD_MY_TIMETABLE = 'LOAD_MY_TIMETABLE';
export const LOAD_MY_TIMETABLE_DONE = 'LOAD_MY_TIMETABLE_DONE';
export const LOAD_MY_TIMETABLE_FAIL = 'LOAD_MY_TIMETABLE_FAIL';

export const LOAD_COURSE_TIMETABLE = 'LOAD_COURSE_TIMETABLE';
export const LOAD_COURSE_TIMETABLE_DONE = 'LOAD_COURSE_TIMETABLE_DONE';
export const LOAD_COURSE_TIMETABLE_FAIL = 'LOAD_COURSE_TIMETABLE_FAIL';
export const SHOW_EXCHANGE_MODE_TIMETABLE = 'SHOW_EXCHANGE_MODE_TIMETABLE';

export const SHOW_COURSE_TIMETABLE = 'SHOW_COURSE_TIMETABLE';
export const HIDE_COURSE_TIMETABLE = 'HIDE_COURSE_TIMETABLE';
export const CONFIRM_EXCHANGE_REQUEST = 'CONFIRM_EXCHANGE_REQUEST';
export const CANCEL_EXCHANGE_MODE = 'CANCEL_EXCHANGE_MODE';
export const CHOOSE_EXCHANGE_FROM_BLOCK = 'CHOOSE_EXCHANGE_FROM_BLOCK';

export const SHOW_DETAIL = 'SHOW_DETAIL';
export const HIDE_DETAIL = 'HIDE_DETAIL';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const RENEW = 'RENEW';

export const REMOVE_BLOCK = 'REMOVE_BLOCK';
export const REMOVE_BLOCK_DONE = 'REMOVE_BLOCK_DONE';
export const REMOVE_BLOCK_FAIL = 'REMOVE_BLOCK_FAIL';

export const EDIT_BLOCK = 'EDIT_BLOCK';
export const EDIT_BLOCK_DONE = 'EDIT_BLOCK_DONE';
export const EDIT_BLOCK_FAIL = 'EDIT_BLOCK_FAIL';

export const ADD_BLOCK = 'ADD_BLOCK';
export const ADD_BLOCK_DONE = 'ADD_BLOCK_DONE';
export const ADD_BLOCK_FAIL = 'ADD_BLOCK_FAIL';
export const HIDE_ADD_BLOCK = 'ADD_BLOCK';

export const LOAD_EXCHANGE_REQUESTS = 'LOAD_EXCHANGE_REQUESTS';
export const LOAD_EXCHANGE_REQUESTS_DONE = 'LOAD_EXCHANGE_REQUESTS_DONE';
export const LOAD_EXCHANGE_REQUESTS_FAIL = 'LOAD_EXCHANGE_REQUESTS_FAIL';

export const NOTIFICATIONS_FETCH_START = 'NOTIFICATIONS_FETCH_START';
export const NOTIFICATIONS_FETCH_DONE = 'NOTIFICATIONS_FETCH_DONE';
export const NOTIFICATIONS_FETCH_FAIL = 'NOTIFICATIONS_FETCH_FAIL';
export const NOTIFICATION_READ_CHANGED = 'NOTIFICATION_READ_CHANGED';

export const MESSAGE_CHANGED = 'MESSAGE_CHANGED';
export const SEND_FEEDBACK_SUCCESS = 'SEND_FEEDBACK_SUCCESS';
export const SEND_FEEDBACK_FAIL = 'SEND_FEEDBACK_FAIL';
export const SET_BLOCKED_HOURS = 'SET_BLOCKED_HOURS';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js